// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");

function exact(beds) {
  return {
    beds: beds,
    bedsRange: false,
    minBeds: undefined,
    maxBeds: undefined
  };
}

function range(minBeds, maxBeds) {
  return {
    beds: undefined,
    bedsRange: true,
    minBeds: minBeds,
    maxBeds: maxBeds
  };
}

function hasInput(bedsState) {
  if (bedsState.bedsRange) {
    if (Stdlib_Option.isSome(bedsState.minBeds)) {
      return true;
    } else {
      return Stdlib_Option.isSome(bedsState.maxBeds);
    }
  } else {
    return Stdlib_Option.isSome(bedsState.beds);
  }
}

function toInput(bedsState) {
  return {
    bedsRange: bedsState.bedsRange ? ({
        maxBeds: bedsState.maxBeds,
        minBeds: bedsState.minBeds
      }) : undefined,
    exactBeds: bedsState.bedsRange ? undefined : ({
        beds: bedsState.beds
      })
  };
}

let empty = {
  beds: undefined,
  bedsRange: false,
  minBeds: undefined,
  maxBeds: undefined
};

exports.empty = empty;
exports.exact = exact;
exports.range = range;
exports.hasInput = hasInput;
exports.toInput = toInput;
/* No side effect */
